import { render, staticRenderFns } from "./SharePopularPage.vue?vue&type=template&id=26ecd5aa&scoped=true&"
import script from "./SharePopularPage.vue?vue&type=script&lang=js&"
export * from "./SharePopularPage.vue?vue&type=script&lang=js&"
import style0 from "./SharePopularPage.vue?vue&type=style&index=0&id=26ecd5aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ecd5aa",
  null
  
)

export default component.exports